app.mediator.registerModule(MODULE_NAME__DASHBOARD, function (app) {

    var helpers = app.helpers.funcs;

    // "Private class" variables

    return {

        $rootElem: null,

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function () {
            var scope = this;
            this.$rootElem = $('.mod-dashboard');
            this.addDomListeners();
            this.addMediatorListeners();
            this.equaliseDivHeights();
            setTimeout(function () {
                scope.equaliseDivHeights();
            }, 2000);
            app.mediator.notify(EVENT_NAME__DASHBOARD__INITIATED);
        },

        //==========================================================xdiv2====
        // Mediator event handlers
        //===================================================================

        addDomListeners: function () {
            var scope = this;
            this.$rootElem.on('click', '.view-feedback-trigger', function () {
                scope.displayFeedback($(this).closest('.card'));
            });
            this.$rootElem.on('click', '.trigger-social-show', function () {
                scope.showShare($(this).closest('.card'));
            });
            this.$rootElem.on('click', '.trigger-social-hide', function () {
                scope.hideShare($(this).closest('.card'));
            });
            $('.mod-dashboard').on('click', '.social-link', function (e) {
                var $socialLinkElem = $(this);
                if ($socialLinkElem.hasClass('social-link-copy')) {
                    scope.socialActionCopy($socialLinkElem.closest('.card'));
                } else {
                    e.preventDefault();
                    var href = $socialLinkElem.attr('href');
                    helpers.openBorderlessLink(href);
                }
                scope.hideShare($(this).closest('.card'));
            });

            app.globalEventRegistry.addListener('resize', helpers.throttler(function () {
                scope.equaliseDivHeights();
            }, 200));

        },

        addMediatorListeners: function () {
            var scope = this;
            this.$rootElem.find('.loopback-btn').focus(function (e) {
                e.preventDefault();
                var $cardElem = $(this).closest('.card');
                scope.goToStartOfSocialShare($cardElem);
			});
        },
		
        //==========================================================xdiv2====
        // Module
        //===================================================================

        equaliseDivHeights: function () {
            var itemsPerRowPerBreakpoint = {};
            itemsPerRowPerBreakpoint[app.helpers.screenBreakpoints.xs] = 1;
            itemsPerRowPerBreakpoint[app.helpers.screenBreakpoints.sm] = 2;
            itemsPerRowPerBreakpoint[app.helpers.screenBreakpoints.md] = 3;
            itemsPerRowPerBreakpoint[app.helpers.screenBreakpoints.lg] = 3;
            helpers.equaliseDivHeights(this.$rootElem.find('.manage-entry-card'), itemsPerRowPerBreakpoint);
        },

        goToStartOfSocialShare: function ($cardElem) {
            var scope = this;
            $cardElem.find('.trigger-social-hide').focus();
        },

        displayFeedback: function ($cardElem) {
            var text = $cardElem.find('.entry-feedback').text();
            var modal = app.ui.uiPlugins.modal;
            modal.setTitle('Feedback');
            modal.setBody(text);
            modal.show();
        },

        showShare: function ($cardElem) {
            var $socialElem = $cardElem.find('.wrap-social');
            $socialElem.stop().fadeIn();
            this.goToStartOfSocialShare($cardElem);
        },

        hideShare: function ($cardElem) {
            var $socialElem = $cardElem.find('.wrap-social');
            $socialElem.stop().fadeOut();
            $cardElem.find('.trigger-social-show').focus();
        },

        socialActionCopy: function ($cardElem) {
            var helpers = app.helpers.funcs;
            var $linkElem = $cardElem.find('.wrap-permalink');
            helpers.copyElementText($linkElem, function (successful) {
                if (successful) app.ui.uiPlugins.toast.fire('Link copied');
            });
        }

	};
});
